/* eslint-disable */

export type IWeddingFairsSettings = {
  beauty?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  cakes?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  catering?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  decoration?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  dress?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  entertainment?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  florist?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  group?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  jewellery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  marquee?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  menswear?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  music?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  photo?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  planners?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  stationery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  transport?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  venue?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  video?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  suppliers?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  '*'?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
} & SupplierTypesSettings;
/**
 * This interface was referenced by `IBucket`'s JSON-Schema
 * via the `definition` "SupplierType".
 */
export type SupplierType =
  | 'beauty'
  | 'cakes'
  | 'catering'
  | 'decoration'
  | 'dress'
  | 'entertainment'
  | 'florist'
  | 'group'
  | 'jewellery'
  | 'marquee'
  | 'menswear'
  | 'music'
  | 'photo'
  | 'planners'
  | 'stationery'
  | 'transport'
  | 'venue'
  | 'video';
export type ITemplatedResponsesSettings = {
  beauty?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  cakes?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  catering?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  decoration?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  dress?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  entertainment?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  florist?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  group?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  jewellery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  marquee?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  menswear?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  music?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  photo?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  planners?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  stationery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  transport?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  venue?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  video?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  suppliers?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  '*'?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
};
export type IAutoFollowUpTemplatedResponsesSettings = {
  beauty?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  cakes?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  catering?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  decoration?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  dress?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  entertainment?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  florist?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  group?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  jewellery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  marquee?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  menswear?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  music?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  photo?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  planners?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  stationery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  transport?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  venue?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  video?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  suppliers?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  '*'?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
} & SupplierTierSettings;
/**
 * This interface was referenced by `IBucket`'s JSON-Schema
 * via the `definition` "SupplierTier".
 */
export type SupplierTier = -1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4;
export type IBadgesSettings = SupplierTierSettings & SupplierTypesSettings;
export type IRealWeddingsSettings = SupplierTierSettings & SupplierTypesSettings;
export type IRealWeddingsCarouselSettings = boolean;
export type IRecommendedSuppliersCarouselSettings = boolean;
export type ITrendingCarouselSuppliersSettings = SupplierTierSettings & SupplierTypesSettings;
export type IROISummarySettings = SupplierTierSettings & SupplierTypesSettings;
export type IInstagramIntegrationSettings = SupplierTierSettings & SupplierTypesSettings;
export type ICouplesActivitySettings = SupplierTierSettings & SupplierTypesSettings;
export type IContactCouplesSettings = {
  beauty?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  cakes?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  catering?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  decoration?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  dress?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  entertainment?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  florist?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  group?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  jewellery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  marquee?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  menswear?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  music?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  photo?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  planners?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  stationery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  transport?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  venue?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  video?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  suppliers?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  '*'?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
} & SupplierTierSettings;
export type ICouplesIntelSettings = SupplierTierSettings & SupplierTypesSettings;
export type ILostLeadsStatsSettings = SupplierTierSettings & SupplierTypesSettings;
export type ILostLeadTrackingSettings = {
  beauty?: number;
  cakes?: number;
  catering?: number;
  decoration?: number;
  dress?: number;
  entertainment?: number;
  florist?: number;
  group?: number;
  jewellery?: number;
  marquee?: number;
  menswear?: number;
  music?: number;
  photo?: number;
  planners?: number;
  stationery?: number;
  transport?: number;
  venue?: number;
  video?: number;
  suppliers?: number;
  '*'?: number;
} & SupplierTierSettings;
export type IYourCompetitorsSettings = SupplierTierSettings & SupplierTypesSettings;
export type IRevealCoupleEmailAddressSettings = SupplierTierSettings & SupplierTypesSettings;
export type IRevealCouplePhoneNumberSettings = SupplierTierSettings & SupplierTypesSettings;
export type ITopSpotSettings = {
  waitlist: boolean;
} & SupplierTierSettings &
  SupplierTypesSettings;
export type IMultiCountySettings = {
  beauty?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  cakes?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  catering?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  decoration?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  dress?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  entertainment?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  florist?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  group?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  jewellery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  marquee?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  menswear?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  music?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  photo?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  planners?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  stationery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  transport?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  venue?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  video?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  suppliers?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  '*'?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
} & SupplierTierSettings;
export type IVenueTypeHeroSettings = {
  waitlist?: boolean;
} & SupplierTierSettings &
  SupplierTypesSettings;
export type ILostLeadsInsightsEnquirySourceSettings = SupplierTierSettings & SupplierTypesSettings;
export type ICoupleTargetingSettings = SupplierTierSettings & SupplierTypesSettings;
export type ICoupleTargetingGuestCountSettings = SupplierTierSettings & SupplierTypesSettings;
export type ILateAvailabilitySettings = SupplierTierSettings & {
  beauty?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  cakes?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  catering?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  decoration?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  dress?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  entertainment?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  florist?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  group?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  jewellery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  marquee?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  menswear?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  music?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  photo?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  planners?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  stationery?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  transport?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  venue?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  video?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  suppliers?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
  '*'?: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
};
export type ICouplesInsigthsSearchAppearancesSettings = SupplierTierSettings & SupplierTypesSettings;
export type ICouplesInsigthsProfileViewsSettings = SupplierTierSettings & SupplierTypesSettings;
export type ICouplesInsigthsEnquiriesSettings = SupplierTierSettings & SupplierTypesSettings;
export type ISpecialOfferRecommendationSettings = SupplierTierSettings & SupplierTypesSettings;
export type ISearchOptimisationSettings = SupplierTierSettings & SupplierTypesSettings;
export type IDealsSettings = SupplierTierSettings & SupplierTypesSettings;
export type IBridebookDiscountsSettings = SupplierTierSettings & SupplierTypesSettings;
export type IVideoToursSettings = SupplierTierSettings & SupplierTypesSettings;
export type IProfessionalNetworkSettings = SupplierTierSettings & SupplierTypesSettings;
export type ISearchPerformanceSettings = SupplierTierSettings & SupplierTypesSettings;
export type ISocialMediaSupportSettings = SupplierTierSettings & SupplierTypesSettings;
export type IMarketInsightsSettings = SupplierTierSettings & SupplierTypesSettings;
export type IMarketInsightsStatsCoupleBudgetSettings = SupplierTierSettings & SupplierTypesSettings;
export type IBridebookInstituteSettings = SupplierTierSettings & SupplierTypesSettings;
export type IUpgradePlanSettings = SupplierTierSettings & SupplierTypesSettings;
export type IWeddingReportsSettings = SupplierTierSettings & SupplierTypesSettings;
export type ISearchBoostSettings = {
  beauty?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  cakes?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  catering?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  decoration?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  dress?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  entertainment?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  florist?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  group?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  jewellery?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  marquee?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  menswear?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  music?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  photo?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  planners?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  stationery?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  transport?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  venue?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  video?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  suppliers?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
  '*'?: {
    comingSoon: {
      '0'?: boolean;
      '1'?: boolean;
      '2'?: boolean;
      '3'?: boolean;
      '4'?: boolean;
      '-1'?: boolean;
      '0.25'?: boolean;
      '0.5'?: boolean;
      '2.5'?: boolean;
    };
    billingPeriod: IBillingPeriod;
  };
} & SupplierTypesSettings;
export type IBillingPeriod = 'monthly' | 'quarterly' | 'yearly';
export type IChargebeePricingTableSettings = {
  beauty?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  cakes?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  catering?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  decoration?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  dress?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  entertainment?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  florist?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  group?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  jewellery?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  marquee?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  menswear?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  music?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  photo?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  planners?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  stationery?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  transport?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  venue?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  video?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  suppliers?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
  '*'?: {
    tableIdByMinTier: {
      '0'?: string;
      '1'?: string;
      '2'?: string;
      '3'?: string;
      '4'?: string;
      '-1'?: string;
      '0.25'?: string;
      '0.5'?: string;
      '2.5'?: string;
    };
  };
};
export type IAdminBannersSettings = boolean;
export type IMessageCenterSettings = SupplierTypesSettings;
export type IBusinessSelfSingUpSettings = boolean;
export type IFeatureTutorialsSettings = boolean;
export type IAboutYouSettings = SupplierTypesSettings;
export type ICountyDropdownSettings = boolean;
export type ISearchPresetsSettings = boolean;
export type ISmartEmailsSettings = boolean;
export type ILocationsSettings = SupplierTypesSettings & SupplierTierSettings;
export type IOnboardingConciergeFlowSettings = boolean;
export type IEnquiryWidgetSettings = SupplierTypesSettings;
export type IWelcomeMessageSettings = SupplierTypesSettings;
export type ITrendsSettings = SupplierTypesSettings & SupplierTierSettings;
export type IHistoricalSearchPositionChartSettings = SupplierTypesSettings & SupplierTierSettings;
export type IKeepRelationsOnTierDowngradeSettings = SupplierTypesSettings & SupplierTierSettings;
export type IReplyToReviewsSettings = SupplierTypesSettings & SupplierTierSettings;
export type IInspirationAndAdviceSettings = boolean;
export type ISpecialOffersCarouselSettings = boolean;
export type IRapidResponderSettings = SupplierTypesSettings & SupplierTierSettings;
export type IFeatureSupplierMarkerSettings = SupplierTierSettings;
export type IYouMayAlsoLikeCarouselSettings = {
  beauty?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  cakes?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  catering?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  decoration?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  dress?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  entertainment?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  florist?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  group?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  jewellery?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  marquee?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  menswear?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  music?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  photo?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  planners?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  stationery?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  transport?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  venue?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  video?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  suppliers?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  '*'?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
};
export type ICouplesAlsoLikeCarouselSettings = {
  beauty?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  cakes?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  catering?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  decoration?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  dress?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  entertainment?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  florist?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  group?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  jewellery?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  marquee?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  menswear?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  music?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  photo?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  planners?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  stationery?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  transport?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  venue?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  video?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  suppliers?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
  '*'?: (-1 | 0 | 0.25 | 0.5 | 1 | 2 | 2.5 | 3 | 4)[];
};
export type IAdditionalImageOnSearchSettings = SupplierTierSettings;
export type IQuickFiltersPillSettings = {
  beauty?: string[];
  cakes?: string[];
  catering?: string[];
  decoration?: string[];
  dress?: string[];
  entertainment?: string[];
  florist?: string[];
  group?: string[];
  jewellery?: string[];
  marquee?: string[];
  menswear?: string[];
  music?: string[];
  photo?: string[];
  planners?: string[];
  stationery?: string[];
  transport?: string[];
  venue?: string[];
  video?: string[];
  suppliers?: string[];
  '*'?: string[];
};
export type IQuickFiltersDropdownSettings = {
  beauty?: string[];
  cakes?: string[];
  catering?: string[];
  decoration?: string[];
  dress?: string[];
  entertainment?: string[];
  florist?: string[];
  group?: string[];
  jewellery?: string[];
  marquee?: string[];
  menswear?: string[];
  music?: string[];
  photo?: string[];
  planners?: string[];
  stationery?: string[];
  transport?: string[];
  venue?: string[];
  video?: string[];
  suppliers?: string[];
  '*'?: string[];
};
export type IRecommendationsSettings = SupplierTierSettings & SupplierTypesSettings;
export type IHideLimitedProfilesSettings = SupplierTypesSettings;
export type IHasEssentialsSettings = SupplierTypesSettings;
export type ISmartPricingSettings = SupplierTypesSettings;
export type IMandatoryOnboardingPhoneNumberSettings = boolean;
export type IFreeTrialSettings = {
  beauty?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  cakes?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  catering?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  decoration?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  dress?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  entertainment?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  florist?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  group?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  jewellery?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  marquee?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  menswear?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  music?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  photo?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  planners?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  stationery?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  transport?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  venue?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  video?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  suppliers?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
  '*'?: {
    tier: number;
    days: number;
    activation: IFreeTrialActivation;
  };
};
export type IFreeTrialActivation = 'manual' | 'signup';
export type IProfileHighlightsSectionSettings = SupplierTypesSettings;
export type ISeoScoreBoostSettings = {
  tiers: {
    '0'?: number;
    '1'?: number;
    '2'?: number;
    '3'?: number;
    '4'?: number;
    '-1'?: number;
    '0.25'?: number;
    '0.5'?: number;
    '2.5'?: number;
  };
} & SupplierTypesSettings;
/**
 * Search filter sections shown to couples, per supplier type. Only venue filters vary by market, so venue is the only type accepted here. Filters for the other supplier types are identical in every market and are defined in the app instead. Add a supplier type key here once its filters need to differ per market.
 */
export type ISearchFiltersSettings = {
  venue?: VenueFilterSections;
};
export type IForcedCuratedListSearchSettings = boolean;
export type IUpcomingShowroundsWidgetSettings = SupplierTierSettings & SupplierTypesSettings;
export type IAiWeddingPlannerSettings = boolean;
export type IMultiShowroundsSettings = boolean;

export interface IBucket {
  id: IBucketID;
  /**
   * Bucket Settings
   */
  settings: {
    weddingFairs: null | IWeddingFairsSettings;
    templatedResponses: null | ITemplatedResponsesSettings;
    autoFollowUpTemplatedResponses: null | IAutoFollowUpTemplatedResponsesSettings;
    badges: null | IBadgesSettings;
    realWeddings: null | IRealWeddingsSettings;
    realWeddingsCarousel: null | IRealWeddingsCarouselSettings;
    recommendedSuppliersCarousel: null | IRecommendedSuppliersCarouselSettings;
    trendingCarouselSuppliers: null | ITrendingCarouselSuppliersSettings;
    roiSummary: null | IROISummarySettings;
    automaticDowngradeTier: null | IAutomaticDowngradeTierSettings;
    instagramIntegration: null | IInstagramIntegrationSettings;
    couplesActivity: null | ICouplesActivitySettings;
    contactCouples: null | IContactCouplesSettings;
    couplesIntel: null | ICouplesIntelSettings;
    lostLeadsStats: null | ILostLeadsStatsSettings;
    lostLeadTracking: null | ILostLeadTrackingSettings;
    yourCompetitors: null | IYourCompetitorsSettings;
    revealCoupleEmailAddress: null | IRevealCoupleEmailAddressSettings;
    revealCouplePhoneNumber: null | IRevealCouplePhoneNumberSettings;
    topSpot: null | ITopSpotSettings;
    multiCounty: null | IMultiCountySettings;
    venueTypeHero: null | IVenueTypeHeroSettings;
    lostLeadsInsightsEnquirySource: null | ILostLeadsInsightsEnquirySourceSettings;
    coupleTargeting: null | ICoupleTargetingSettings;
    coupleTargetingGuestCount: null | ICoupleTargetingGuestCountSettings;
    lateAvailability: null | ILateAvailabilitySettings;
    couplesInsightsSearchAppearances: null | ICouplesInsigthsSearchAppearancesSettings;
    couplesInsightsProfileViews: null | ICouplesInsigthsProfileViewsSettings;
    couplesInsightsEnquiries: null | ICouplesInsigthsEnquiriesSettings;
    specialOfferRecommendation: null | ISpecialOfferRecommendationSettings;
    searchOptimisation: null | ISearchOptimisationSettings;
    deals: null | IDealsSettings;
    bridebookDiscounts: null | IBridebookDiscountsSettings;
    videoTours: null | IVideoToursSettings;
    professionalNetwork: null | IProfessionalNetworkSettings;
    searchPerformance: null | ISearchPerformanceSettings;
    socialMediaSupport: null | ISocialMediaSupportSettings;
    marketInsightsStats: null | IMarketInsightsSettings;
    marketInsightsStatsCoupleBudget: null | IMarketInsightsStatsCoupleBudgetSettings;
    bridebookInstitute: null | IBridebookInstituteSettings;
    upgradePlan: null | IUpgradePlanSettings;
    weddingReports: null | IWeddingReportsSettings;
    searchBoost: null | ISearchBoostSettings;
    chargebeePricingTable: null | IChargebeePricingTableSettings;
    adminBanners: null | IAdminBannersSettings;
    messageCenter: null | IMessageCenterSettings;
    businessSelfSignUp: null | IBusinessSelfSingUpSettings;
    featureTutorials: null | IFeatureTutorialsSettings;
    aboutYou: null | IAboutYouSettings;
    countyDropdown: null | ICountyDropdownSettings;
    searchPresets: null | ISearchPresetsSettings;
    smartEmails: null | ISmartEmailsSettings;
    locations: null | ILocationsSettings;
    onboardingConciergeFlow: null | IOnboardingConciergeFlowSettings;
    enquiryWidget: null | IEnquiryWidgetSettings;
    welcomeMessage: null | IWelcomeMessageSettings;
    trends: null | ITrendsSettings;
    historicalSearchPositionChart: null | IHistoricalSearchPositionChartSettings;
    keepRelationsOnTierDowngrade: null | IKeepRelationsOnTierDowngradeSettings;
    replyToReviews: null | IReplyToReviewsSettings;
    inspirationAndAdvice: null | IInspirationAndAdviceSettings;
    specialOffersCarousel: null | ISpecialOffersCarouselSettings;
    rapidResponder: null | IRapidResponderSettings;
    featuredSupplierMarker: null | IFeatureSupplierMarkerSettings;
    youMayAlsoLikeCarousel: null | IYouMayAlsoLikeCarouselSettings;
    couplesAlsoLikeCarousel: null | ICouplesAlsoLikeCarouselSettings;
    additionalImageOnSearch: null | IAdditionalImageOnSearchSettings;
    quickFiltersPill: null | IQuickFiltersPillSettings;
    quickFiltersDropdown: null | IQuickFiltersDropdownSettings;
    recommendations: null | IRecommendationsSettings;
    hideLimitedProfiles: null | IHideLimitedProfilesSettings;
    hasEssentials: null | IHasEssentialsSettings;
    smartPricing: null | ISmartPricingSettings;
    mandatoryOnboardingPhoneNumber: null | IMandatoryOnboardingPhoneNumberSettings;
    freeTrial: null | IFreeTrialSettings;
    profileHighlightsSection: null | IProfileHighlightsSectionSettings;
    seoScoreBoost: null | ISeoScoreBoostSettings;
    searchFilters: null | ISearchFiltersSettings;
    forcedCuratedListSearch: null | IForcedCuratedListSearchSettings;
    upcomingShowroundsWidget: null | IUpcomingShowroundsWidgetSettings;
    aiWeddingPlanner: null | IAiWeddingPlannerSettings;
    multiShowrounds: null | IMultiShowroundsSettings;
  };
}
/**
 * Supplier Type Settings
 *
 * This interface was referenced by `IBucket`'s JSON-Schema
 * via the `definition` "SupplierTypeSettings".
 */
export interface SupplierTypesSettings {
  types:
    | {
        excluded?: (SupplierType | 'suppliers')[];
        included: '*' | (SupplierType | 'suppliers')[];
      }
    | {
        excluded: (SupplierType | 'suppliers')[];
        included?: '*' | (SupplierType | 'suppliers')[];
      };
}
/**
 * Supplier Tier Settings
 *
 * This interface was referenced by `IBucket`'s JSON-Schema
 * via the `definition` "SupplierTierSettings".
 */
export interface SupplierTierSettings {
  tier: {
    minimum: SupplierTier;
    minimumByType?: Partial<Record<SupplierType, SupplierTier>>;
  };
}
export interface IAutomaticDowngradeTierSettings {
  beauty?: SupplierTier;
  cakes?: SupplierTier;
  catering?: SupplierTier;
  decoration?: SupplierTier;
  dress?: SupplierTier;
  entertainment?: SupplierTier;
  florist?: SupplierTier;
  group?: SupplierTier;
  jewellery?: SupplierTier;
  marquee?: SupplierTier;
  menswear?: SupplierTier;
  music?: SupplierTier;
  photo?: SupplierTier;
  planners?: SupplierTier;
  stationery?: SupplierTier;
  transport?: SupplierTier;
  venue?: SupplierTier;
  video?: SupplierTier;
  suppliers?: SupplierTier;
  '*'?: SupplierTier;
}
/**
 * Search Filter Sections
 *
 * This interface was referenced by `IBucket`'s JSON-Schema
 * via the `definition` "VenueFilterSections".
 */
export interface VenueFilterSections {
  priceSection?: string[] | boolean;
  guestsSection?: string[] | boolean;
  overviewSection?: string[] | boolean;
  distanceSection?: string[] | boolean;
  upcomingEvents?: string[] | boolean;
  accommodationRoomsSection?: string[] | boolean;
  venueType?: string[] | boolean;
  venueStyle?: string[] | boolean;
  venueFeatures?: string[] | boolean;
  foodDrinkSection?: string[] | boolean;
  specialOffers?: string[] | boolean;
  specialistWeddingSection?: string[] | boolean;
  diversityAndInclusion?: string[] | boolean;
}
/**
 * This interface was referenced by `IBucket`'s JSON-Schema
 * via the `definition` "EnabledSettings".
 */
export interface EnabledSettings {
  enabled: boolean;
}
/**
 * Supplier Type or Wildcard Settings
 *
 * This interface was referenced by `IBucket`'s JSON-Schema
 * via the `definition` "SupplierTypeOrWildcardSettings".
 */
export interface SupplierTypeOrWildcardSettings {
  types: {
    beauty?: boolean;
    cakes?: boolean;
    catering?: boolean;
    decoration?: boolean;
    dress?: boolean;
    entertainment?: boolean;
    florist?: boolean;
    group?: boolean;
    jewellery?: boolean;
    marquee?: boolean;
    menswear?: boolean;
    music?: boolean;
    photo?: boolean;
    planners?: boolean;
    stationery?: boolean;
    transport?: boolean;
    venue?: boolean;
    video?: boolean;
    suppliers?: boolean;
    '*'?: boolean;
  };
}

/**
 * Bucket ID
 */
export enum IBucketID {
  ESTABLISHED = 'established',
  SCALING = 'scaling',
  EMERGING = 'emerging',
  FUTURE = 'future',
  LITE = 'lite',
}
